import { createUseStyles } from 'react-jss';
import AlertImage from '../../assets/Alert.svg';
import UploadImage from '../../assets/Upload.svg';

export default createUseStyles({
  root: {
    position: 'relative',
    width: '64px',
    height: '64px',
    margin: 0,
    padding: 0,
  },

  icon: {
    width: '64px',
    height: '64px',
  },

  alertIcon: {
    backgroundImage: `url(${AlertImage})`,
  },

  uploadIcon: {
    backgroundImage: `url(${UploadImage})`,
  },

  deleteIcon: {
    backgroundImage: `url(${UploadImage})`,
  },
});
